<template>
    <div>
      
    </div>
</template>

<script>
import mqtt from 'mqtt'
import { MQTT_SERVICE, MQTT_USERNAME, MQTT_PASSWORD } from './sysconstant.js'
var client;
export default {
  name: 'Mqtt',
  props:['imei'],
  data () {
    return {
      msg: '',
      myimei:'',
      sendmsg:'',
      times:1,
      timeid:0,
      machineStatus:"N",
    }
  },
  created () {
    //this.testOnLine()
  },
  methods: {
    testOnLine(imei){
      var url = "https://home.hrcc8.com/home/api/c/testOnline/?imei="+imei
      this.axios.get(url)
      .then((res) =>{
        console.log(res)
        if(res.data.code === 20000){
          if(this.machineStatus == "N"){
            this.machineStatus = "on";
          }
          this.$emit("machineStatus","on")
        }else{
          this.machineStatus = "off";
          this.$emit("machineStatus","off",res.data.msg)
        }
      })
      .catch((error)=>{
        this.$emit("machineStatus","off",error)
      })
    }
    // mqttMSG (myimei) {
    //     this.myimei = myimei;
    //     this.sendmsg = '{"IMEI":"'+ myimei +'","Command":10}';
    //     console.log('start')
    //     var sj = Math.floor((Math.random()*100)+1);
    //     const options = {
    //       connectTimeout: 60000,
    //       keepalive:60,
    //       clientId: "app-c-"+(new Date()).valueOf()+"-"+sj,
    //       username: MQTT_USERNAME,
    //       password: MQTT_PASSWORD,
    //       clean: true
    //     }
    //     //console.log(options);
    //   client = mqtt.connect(MQTT_SERVICE, options)
    //   // mqtt连接
    //   client.on('connect', (e) => {
    //     console.log('连接成功:')
    //     client.subscribe('/topic/State1/'+this.myimei, { qos: 0 }, (error) => {
    //       if (!error) {
    //         console.log('订阅成功')
    //         //发布一个消息
    //         console.log(this.sendmsg)
    //         client.publish('/topic/get/'+this.myimei,this.sendmsg)
    //         console.log('****')
    //         console.log(this.myimei)
    //         this.sendmessage()
    //       } else {
    //         console.log('订阅失败')
    //       }
    //     })
    //   })
 
    //   // 接收消息处理
    //   client.on('message', (topic, message) => {
    //     console.log('收到来自', topic, '的消息', message.toString());
    //     this.msg = message.toString();
    //     //将返回的数据转为json
    //     var data = JSON.parse(this.msg) 
    //     //console.log(data)
    //     //关闭定时器
    //     if(data.State1 == "OK"){
    //       clearInterval(this.timeid);
    //       if(this.machineStatus == "N")
    //       {
    //         this.machineStatus = "on";
    //         this.$emit("machineStatus","on")
    //       }
    //     }
    //     //关闭连接
    //     client.end();
    //   })
    //   // 断开发起重连
    //   client.on('reconnect', (error) => {
    //     console.log('正在重连:', error);
    //     //关闭连接
    //     client.end();
    //   })
    //   // 链接异常处理
    //   client.on('error', (error) => {
    //     console.log('连接失败:', error);
    //     //关闭连接
    //     client.end();
    //   })
    // },
    // sendmessage:function(){
    //   var that = this
    //   //启用定时器  间隔时间5s
    //   that.timeid = setInterval(function(){
    //     client.publish('/topic/get/'+that.myimei,that.sendmsg)
    //     that.times += 1;
    //     console.log(1);
    //     //重发3次关闭定时器
    //     if(that.times >= 3){
    //       //关闭连接
    //       client.end();
    //       console.log(that.times);
    //       clearInterval(that.timeid);
    //       //再过5秒判断  如果没有接收到返回消息就将货机状态置为离线
    //       that.timeoutChangeStatus();
          

    //     }
    //   },5000)
    // },
    // timeoutChangeStatus:function(){
    //   if(this.machineStatus == "N")
    //   {
    //     this.machineStatus = "off";
    //     this.$emit("machineStatus","off")
    //     console.log(this.machineStatus)
    //   }
    //   //延时5s
    //   //var that = this
    //   // setTimeout(function(){
    //   //   if(that.machineStatus == "N")
    //   //   {
    //   //     that.machineStatus = "off";
    //   //     that.$emit("machineStatus","off")
    //   //     console.log(that.machineStatus)
    //   //   }
    //   // }, 5000 );

    // }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Mqtt/Mqtt.vue